import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Table, Tag } from 'antd';
import { tableSize, tableYScroll } from './settings';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import DragableBodyRow from './drag_and_drop';
import './exam_item.css';

class ExamTable extends React.Component {

	constructor(props) {
		super(props);

		this.columns = [
			{
				title: 'EXAM RESULT ID',
				dataIndex: 'examItemID',
				width: 150,
			},
			{
				title: 'EXAM RESULT NAME',
				dataIndex: 'examItemName',

				sorter: (a, b) => { return a.examItemName.localeCompare(b.examItemName) },
				width: 400,
			},
			{
				title: 'ALTERNATIVE NAME',
				dataIndex: 'examItemGeneralName',
				sorter: (a, b) => { return a.examItemGeneralName.localeCompare(b.examItemGeneralName) },
				width: 300,
			},
			{
				title: 'EXAM RESULT TYPE',
				dataIndex: 'examItemTypeCode',

				sorter: (a, b) => { return a.examItemTypeCode.localeCompare(b.examItemTypeCode) },
				width: 200,
			},
			{
				title: 'INTEGRATION CODE',
				dataIndex: 'examItemIntegrationCode',
				width: 180,
				sorter: (a, b) => {
					const aItem = a.examItemIntegrationCode || ''
					const bItem = b.examItemIntegrationCode || ''

					return aItem.localeCompare(bItem)
				}
			},
			{
				title: 'STATUS',
				dataIndex: 'active',
				width: 120,
				sorter: false,
				render: active => (
					<Tag color={active === 0 ? "red" : "green"}>
						{active === 0 ? 'INACTIVE' : 'ACTIVE'}
					</Tag>
				)
			}
		];

		this.components = {
			body: {
				row: DragableBodyRow,
			},
		};
	}

	moveRow = (dragIndex, hoverIndex) => {
		const { onDragAndDropRow, data, pageSize, currentPage } = this.props;
		// Calculate the offset based on current page (1-based index)
		const offset = (currentPage - 1) * pageSize;

		const globalDragIndex = dragIndex + offset;
		const globalHoverIndex = hoverIndex + offset;

		const dragRow = data[globalDragIndex];

		const updatedData = update(this.props, {
			data: { $splice: [[globalDragIndex, 1], [globalHoverIndex, 0, dragRow]] }
		});

		onDragAndDropRow(updatedData.data);
	};

	render() {
		const { data, pageSize, currentPage, loading = false, onRowDblClick, onPageChange } = this.props;

		// const getSelectedExamItems = () => {
		// 	const { data } = this.props;
		// 	const { getFieldsValue } = this.props.form;
		// 	const fieldsValue = getFieldsValue();
		// 	const examItems = [];

		// 	// const keys = data.map((item, index) => fieldsValue[`keys_${index}`]);
		// 	const keys = data.map((item, index) => ({ 
		// 		key: item.examItemID,
		// 		sortCount: index + 1
		// 	}));

		// 	keys.forEach(({ key, sortCount }) => {
		// 		examItems.push({
		// 			examItemID: key,
		// 			examRequestItemGroup: fieldsValue[`examRequestItemGroup_${key}`],
		// 			examRequestItemFormula: fieldsValue[`examRequestItemFormula_${key}`],
		// 			examRequestItemLock: fieldsValue[`examRequestItemLock_${key}`] ? 1 : 0,
		// 			examRequestItemPrintable: fieldsValue[`examRequestItemPrintable_${key}`] ? 1 : 0,
		// 			// examRequestItemSort: index + 1
		// 			examRequestItemSort: sortCount
		// 		});
		// 	});

		// 	return examItems;
		// }

		return (
			<div style={{ marginTop: 20 }} className="settings-exam-item-table">
				<Spin spinning={loading} tip="Loading...">
					<DndProvider backend={HTML5Backend}>
						<Table
							size={tableSize}
							pagination={{
								pageSize,
								current: currentPage,
								showSizeChanger: false,
								hideOnSinglePage: true,
								position: ['bottomRight'],
								onChange: onPageChange
							}}
							columns={this.columns}
							dataSource={data}
							components={this.components}
							scroll={{ x: 1190 }}
							rowKey={record => record.examItemID}
							onRow={(record, index) => ({
								index,
								moveRow: this.moveRow,
								onDoubleClick: () => onRowDblClick(record)
							})}
						/>
					</DndProvider>
				</Spin>
			</div>
		);
	}
}


ExamTable.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		examItemID: PropTypes.number.isRequired,
		examItemName: PropTypes.string.isRequired,
		examItemGeneralName: PropTypes.string.isRequired,
		examItemTypeCode: PropTypes.string.isRequired,
		examItemUnitCode: PropTypes.string,
	})).isRequired,
	pageSize: PropTypes.number.isRequired,
	currentPage: PropTypes.number,
	loading: PropTypes.bool.isRequired,
	onRowDblClick: PropTypes.func.isRequired,
	onDragAndDropRow: PropTypes.func.isRequired,
	onPageChange: PropTypes.func,
};

export default ExamTable;